'use client';

import Image from 'next/image';
import { getReadableImageUrl } from '@/lib/directus'
import { sanitizeHTML } from '@/lib/utils'
import Link from 'next/link'

interface SecAboutProps {
	heading?: {
		title?: string
	}
	text?: {
		text?: string
	}
	image?: {
		alt: string
		image_file: {
			image: {
				id: string
				filename_download: string
			}
		}
	}
	button?: {
		label?: string
		href?: string
	}
}

export const fields = [
	'heading.title',
	'text.text',

	'image.alt',
	'image.image_file.image.id',
	'image.image_file.image.filename_download',

	'button.label',
	'button.href',
]

	export default function SecAbout({ data }: { data: SecAboutProps }) {
	return (
		<section className='SecAbout relative bg-[#737a7d] w-full py-0 overflow-hidden'>
			<div className='relative grid grid-cols-1 md:grid-cols-[60%_40%] md:items-center'>
				{/* Left column with image */}
				<div className='relative w-full h-[25rem] md:h-auto md:aspect-[16/10] overflow-hidden'>
					<Image
						src={
							data?.image?.image_file?.image?.id
								? getReadableImageUrl(
										data.image.image_file.image.id,
										data.image.image_file.image.filename_download
								  )
								: ''
						}
						alt={data?.image?.alt || ''}
						className='object-cover md:object-top'
						fill
						priority
						sizes='(max-width: 768px) 100vw, 60vw'
						quality={90}
					/>
				</div>

				{/* Right column with content */}
				<div className='relative z-10 w-full md:w-auto bg-neutral-50 md:rounded-lg flex flex-col gap-12 md:self-center md:-ml-24 pt-16 md:pt-20 p-8 2xl:p-24 md:my-10 md:p-14 md:pr-3 -mt-[3.75rem] max-md:rounded-tr-[3.125rem]'>
					{/* H Logo - positioned as overlay between sections */}
					<div className='absolute -top-[1.875rem] md:top-1/2 lg:top-1/3 lg:right-auto lg:left-[-4.375rem] left-35 md:transform md:-translate-y-1/2 md:-translate-x-1/2 lg:translate-x-0 z-10'>
						<Image
							src='/images/logo_h.svg'
							alt='Harmon Logo'
							width={112}
							height={112}
							className='w-16 md:w-28 h-16 md:h-28'
							priority
						/>
					</div>

					{/* Heading */}
					<div className='flex flex-col items-start gap-6'>
						<h2>{data?.heading?.title || ''}</h2>
					</div>

					{/* Main text */}
					<div
						className='grid gap-8'
						dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || '')}
					/>

					{data?.button?.label && (
						<Link
							href={data.button?.href || '/'}
							className='btn'
						>{data.button.label}
						</Link>
					)}
				</div>
			</div>
		</section>
	)
}